import { render, staticRenderFns } from "./SearchBoxCategoriaEmitente.vue?vue&type=template&id=6c98fdd2&scoped=true"
import script from "./SearchBoxCategoriaEmitente.vue?vue&type=script&lang=js"
export * from "./SearchBoxCategoriaEmitente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c98fdd2",
  null
  
)

export default component.exports